import axios from "axios";

export const getParticipantList = async (
  baseUrl,
  token,
  trainerId,
  projectId,
  participantId
) => {
  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };

  let getResponse = null;

  await axios
    .get(
      baseUrl +
        "/meeting/" +
        trainerId +
        "/" +
        projectId +
        "/participants/" +
        participantId,
      config
    )
    .then((res) => {
      getResponse = {
        status: res.data.status,
        data: res.data,
      };
    })
    .catch((error) => {
      if (error.response !== undefined) {
        getResponse = {
          status: error.response.status,
          data: error.response.status,
        };
      }
    });
  return getResponse;
};

export const insertParticipant = async (baseUrl, participant) => {
  let postResponse = null;

  await axios
    .post(baseUrl + "/meeting/participant", participant)
    .then((res) => {
      postResponse = {
        status: res.data.status,
        data: res.data,
      };
    })
    .catch((error) => {
      if (error.response !== undefined) {
        postResponse = {
          status: error.response.status,
          data: error.response.status,
        };
      }
    });
  return postResponse;
};

export const getAllParticipantList = async (
  baseUrl,
  token,
  trainerId,
  projectId
) => {
  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };

  let getResponse = null;

  await axios
    .get(
      baseUrl + "/meeting/" + trainerId + "/" + projectId + "/participants/0",
      config
    )
    .then((res) => {
      getResponse = {
        status: res.data.status,
        data: res.data,
      };
    })
    .catch((error) => {
      if (error.response !== undefined) {
        getResponse = {
          status: error.response.status,
          data: error.response.status,
        };
      }
    });
  return getResponse;
};

export const startParticipant = async (baseUrl, participantId) => {
  let putResponse = null;

  await axios
    .put(baseUrl + "/meeting/participant/start/" + participantId)
    .then((res) => {
      putResponse = {
        status: res.data.status,
        data: res.data,
      };
    })
    .catch((error) => {
      if (error.response !== undefined) {
        putResponse = {
          status: error.response.status,
          data: error.response.status,
        };
      }
    });
  return putResponse;
};
